import Api from '@/services/Api';

export default {
	async getNotes(propertyId) {
		return await Api.get(`/api/property/${propertyId}/notes`);
	},
	async updateNote(note) {
		if (note.id) {
			return await Api.patch(`/api/note/${note.id}/update`, note);
		}

		return await Api.post('/api/note', note);
	},
	async deleteNote(id) {
		return await Api.delete('/api/note/delete', { data: { note_id: id } });
	}
};
